import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import lng from '../../../misc/lng';
import { useFontSize } from '../../../contexts/FontSizeContext';


const { chiLng } = lng;
const useStyles = makeStyles(() => ({
    wrapper: {

        marginTop: '10px',
        transition: 'height 0.5s',
        borderRadius: '5px',
        overflowY: 'auto',
    },
    wrapperSm: {
        width: '100%',
        marginTop: '10px',
        transition: 'height 0.5s',
        borderRadius: '5px',
        overflowY: 'auto',
    },
    wrapperSm: {
        width: '100%',
        marginTop: '10px',
        transition: 'height 0.5s',
        borderRadius: '5px',
        overflowY: 'auto',
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px',
        marginBottom: '5px',
    },
    contentWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px',

    },
    priceAfterDiscountWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '0 5px',
        marginTop: '10px',
    },
    openBtn: {
        padding: '0 12px'
    },
    title: {
        opacity: '0.7',
        // marginTop: '10px'
    }
}));

const DiscountDisplayGrid = (props) => {
    const classes = useStyles();
    const { getFontSize } = useFontSize();

    // Dynamic font sizes
    const titleFontSize = getFontSize('bodyText');
    const priceFontSize = getFontSize('priceMain');

    const [open, setOpen] = useState(false);

    const {priceAfterDiscount, totalPrice, discountPrice, tagSetDiscountList} = props.productSummary;


    const getPriceFormula = () => {
        if (discountPrice > 0) {
            return `$(${totalPrice} - ${discountPrice})`
        }
        else {
            return '';
        }
    }
    const getWrapperClasses = () => {
        if (props.width === 'sm') {
            return classes.wrapperSm
        } else if (props.width === 'md') {
            return classes.wrapperMd
        }
        return classes.wrapper;
    }
    return (
        <div className={getWrapperClasses()}>
            <div>
                <React.Fragment>
                    
                    {/* Price before discount */}
                    <div className={classes.contentWrapper}>
                        <Typography variant="inherit" className={classes.title} style={{ fontSize: titleFontSize }}>
                            小計
                        </Typography>
                        <Typography variant="inherit" className={classes.title} style={{ fontSize: priceFontSize }}>
                            ${totalPrice.toFixed(2)}
                        </Typography>
                    </div>

                    <div className={classes.titleWrapper}>
                        <Typography
                            variant="inherit"
                            className={classes.title}
                            style={{ fontSize: titleFontSize }}
                        >
                            {chiLng.discounTitle}
                        </Typography>
                    </div>
                    <Divider />
                    {
                        tagSetDiscountList.map(
                            (discount) => {
                                return (
                                    <div className={classes.contentWrapper} key={discount.id}>
                                        <Typography
                                            variant="inherit"
                                            className={classes.title}
                                            style={{ fontSize: titleFontSize }}
                                        >
                                            {`${discount.name} x ${discount.qty}`}
                                        </Typography>
                                        <Typography
                                            variant="inherit"
                                            className={classes.price}
                                            style={{ fontSize: priceFontSize }}
                                        >
                                            {`- $${discount.price * discount.qty}`}
                                        </Typography>
                                    </div>
                                );
                            }
                        )
                    }
                </React.Fragment>
            </div>
        </div>
    );
};

DiscountDisplayGrid.propTypes = {
    width: PropTypes.string,
};

DiscountDisplayGrid.defaultProps = {
    width: 'sm'
};
export default DiscountDisplayGrid;